import {ConfirmationModalProps} from './types'
import ConfirmationPromiseModalView from './ConfirmationPromiseModalView'

import React from 'react'

const ConfirmationPromiseModal = (props: ConfirmationModalProps): React.ReactElement => <ConfirmationPromiseModalView {...props} />

export default ConfirmationPromiseModal
